import { useReducer, useMemo, createContext, useContext } from 'react'
import { reducer } from './Reducer'

const initialState = {
	user: {
		authenticated: false,
	},
	rfqList: [],
	currentRfqItem: {},
	leads: [],
	currentLeadItem: {},
	occupancies: {},
	occupancy_mapping: {},
}

const initialContext = [{ ...initialState }, () => {}]

export const Context = createContext(initialContext)

export const useContextApi = () => {
	const context = useContext(Context)
	if (!context) {
		throw new Error('useContextApi must be used within AuthProvider')
	}
	return context
}

export function Provider({ children, ...props }) {
	const [state, dispatch] = useReducer(reducer, initialState)
	const value = useMemo(() => [state, dispatch], [state])

	return <Context.Provider value={value}>{children}</Context.Provider>
}
